import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import Applications from "../../components/User/Applications";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const AppliedApplications = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <DashboardLayout pageTitle={language ? "आवेदन" : "Application"} mainClass="p-6">
      <Applications
        title={language ? "जमा किए गए आवेदन" : "Approved Applications"}
        status={[
          applicationStatusMap?.applied,
          applicationStatusMap?.incompleteDocumentPending,
          applicationStatusMap?.incompleteInformation,
          applicationStatusMap?.tifcVerified,
          applicationStatusMap?.dlctUnverified,
          applicationStatusMap?.dlctVerified,
          applicationStatusMap?.rejected,
          applicationStatusMap?.nodalIncompleteInformation
        ]}
      />
    </DashboardLayout>
  );
};

export default AppliedApplications;
